// extracted by mini-css-extract-plugin
module.exports = {"footer_content_spacing":"styles_footer_content_spacing__1CPWk","footer_rebrand_border_r":"styles_footer_rebrand_border_r__zfTBq"};